if (!customElements.get('bundle-feature-section')) {
  customElements.define('bundle-feature-section', class BundleFeatureSection extends HTMLElement {
    constructor() {
      super();
      
      // Add to cart functionality
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId ? parseInt(this.dataset.variantId) : null;
      this.button = this.querySelector('[data-add-to-cart]');
      this.cartDrawer = document.querySelector('cart-drawer');
      
      // Get product JSON data
      const productJsonElement = this.querySelector('.bundle-feature-product-json') || document.querySelector('.bundle-feature-product-json');
      if (productJsonElement) {
        try {
          this.productData = JSON.parse(productJsonElement.textContent);
          if (this.productData && this.productData.product) {
            // Get the first/default variant
            const firstVariant = this.productData.product.variants.find(v => v.id === this.productData.selectedOrFirstAvailableVariant) || this.productData.product.variants[0];
            if (firstVariant) {
              this.variantId = firstVariant.id;
            }
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    }

    connectedCallback() {
      // Initialize add to cart functionality
      if (this.button && this.variantId) {
        this.button.addEventListener('click', this.handleAddToCart.bind(this));
      }
    }

    async handleAddToCart(event) {
      event.preventDefault();

      if (!this.button || !this.variantId) {
        return;
      }

      if (this.button.classList.contains('is-loading') || this.button.disabled) {
        return;
      }

      // Show loading state
      this.button.classList.add('is-loading');
      this.button.disabled = true;

      try {
        // Use the simpler /cart/add.js API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ 
            id: this.variantId, 
            quantity: 1 
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Check if there's an error in the response
        if (data.status) {
          console.error('Add to cart error:', data.description);
          this.showError(data.description);
          this.button.classList.remove('is-loading');
          this.button.disabled = false;
          return;
        }

        // Success - fetch cart and open drawer
        const cart = await this.fetchCart();
        
        if (this.cartDrawer) {
          this.cartDrawer.open(cart);
          this.cartDrawer.setActiveElement(this.button);
          
          // Dispatch cart update event
          const cartUpdateEvent = new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart }
          });
          document.dispatchEvent(cartUpdateEvent);
        } else {
          // redirect to cart page
          window.location.href = '/cart';
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showError('Unable to add product to cart. Please try again.');
      } finally {
        // Remove loading state
        this.button.classList.remove('is-loading');
        this.button.disabled = false;
      }
    }

    async fetchCart() {
      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'include',
      });
      return await response.json();
    }

    showError(message) {
      console.error(message);
      // Optionally show a toast or error message to the user
    }
  });
}
